import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import {
  updateJobAlertCreateDialog,
  updateJobAlertCreateDialogWithKeyword,
  updateVisitorJobAlertDialogDetails,
} from "../../../redux/actions/dialog_action";
import { updateJobAlertEmail } from "../../../redux/actions/job_action";
import { checkAuthentication } from "../../../redux/actions/user_action";
import {
  AlertCopyText,
  ButtonContainer,
  CheckCircleIconStyled,
  CloseIconStyled,
  ContentContainer,
  IconButtonStyled,
  InputBaseAdornmentStyled,
  InputBaseStyled,
  JobAlertContainer,
  LabelContainer,
  NotificationsIconStyled,
  PaperPlaneIconStyled,
  SetAlertButtonStyled,
} from "./styles";

function JobAlertToggle(props) {
  const { jobAlertBannerId } = props;

  const isMobile = useMediaQuery("(max-width:640px)");

  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslation();

  const isLoggedIn = checkAuthentication();

  const jobAlerts = useSelector((state) => state.jobs.jobAlerts);
  const searchKeyword =
    useSelector((state) => state.jobs.jobListFilter.keyword) ?? "";
  const showSignInModal = useSelector((state) => state.navbar.showSignInModal);
  const showJobAlertVisitorEmailDialog = useSelector(
    (state) => state.dialog.showJobAlertVisitorEmailDialog
  );

  const [active, setActive] = useState(false);
  const [showJobAlertBanner, setShowJobAlertBanner] = useState(true);

  const url = window.location.search;
  const urlParams = new URLSearchParams(url);
  const cAlert = urlParams.get("title");

  const toggleText = () => {
    if (active) {
      return t("jobs.job_alert_created");
    } else {
      if (isMobile) {
        return "";
      } else {
        return t("jobs.get_notified_similar_jobs");
      }
    }
  };

  function checkJobAlertExists(keyword) {
    if (!keyword) return;

    return jobAlerts.some((alert) => {
      const alertTitle = alert.title?.toString().toLowerCase().trim();
      const keywordLower = keyword.toString().toLowerCase().trim();
      return alertTitle === keywordLower;
    });
  }

  function handleCloseBanner() {
    sendTrackingEvent({
      event: "CE_close-job-alert-banner",
    });
    setShowJobAlertBanner(false);
  }

  function handleEmailInputChange(event) {
    dispatch(
      updateVisitorJobAlertDialogDetails({
        email: event.target.value,
      })
    );
    dispatch(updateJobAlertEmail(event.currentTarget.value));
  }

  function handleSetVisitorAlert() {
    // dispatch(
    //   updateVisitorJobAlertDialogDetails({
    //     keyword: searchKeyword,
    //   })
    // );
    // dispatch(updateVisitorJobAlertDialogOrigin("job-alert-banner"));
    dispatch(
      updateJobAlertCreateDialogWithKeyword({
        keyword: searchKeyword ?? "",
        origin: "job-alert-banner",
      })
    );
    dispatch(updateJobAlertCreateDialog(true));
    // dispatch(updateShowJobAlertDialog(true));
  }

  function handleSetAlert() {
    return active
      ? router.push("/profile#manage-job-alerts")
      : dispatch(
          updateJobAlertCreateDialogWithKeyword({
            keyword: searchKeyword,
            origin: "job-alert-banner",
          })
        ).then(() => dispatch(updateJobAlertCreateDialog(true)));
  }

  useEffect(() => {
    if (cAlert && cAlert == searchKeyword) {
      setActive(true);
    }
  }, [cAlert, searchKeyword]);

  useEffect(() => {
    // Only for visitor
    if (!isLoggedIn && searchKeyword) {
      if (showJobAlertVisitorEmailDialog || showSignInModal) {
        setActive(true);
      } else {
        setActive(false);
      }
    }
  }, [showJobAlertVisitorEmailDialog, showSignInModal]);

  useEffect(() => {
    if (checkJobAlertExists(searchKeyword)) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [jobAlerts]);

  return (
    <JobAlertContainer
      id={jobAlertBannerId}
      open={showJobAlertBanner}
      $active={active}
    >
      <ContentContainer>
        <LabelContainer $active={active}>
          {!active ? <NotificationsIconStyled /> : <CheckCircleIconStyled />}
          {isLoggedIn || !isMobile ? (
            <AlertCopyText>{toggleText()}</AlertCopyText>
          ) : null}
        </LabelContainer>
        <ButtonContainer>
          {isLoggedIn ? (
            <SetAlertButtonStyled variant="contained" onClick={handleSetAlert} data-testid="job-alert-set-btn">
              {active
                ? t("jobs.manage_job_alerts")
                : t("jobs.set_alert")}
            </SetAlertButtonStyled>
          ) : (
            <InputBaseStyled
              $active
              data-testid="job-alert-email-input"
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleSetVisitorAlert();
                }
              }}
              placeholder={
                isMobile
                  ? t("jobs.enter_email_updates")
                  : t("jobs.your_email_address")
              }
              onChange={handleEmailInputChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={handleSetAlert}>
                    <InputBaseAdornmentStyled>
                      {isMobile ? (
                        <PaperPlaneIconStyled />
                      ) : (
                        t("jobs.set_alert")
                      )}
                    </InputBaseAdornmentStyled>
                  </IconButton>
                </InputAdornment>
              }
            />
          )}

          <IconButtonStyled
            aria-label={t("jobs.close")}
            data-testid="job-alert-close-btn"
            size="small"
            onClick={handleCloseBanner}
          >
            <CloseIconStyled />
          </IconButtonStyled>
        </ButtonContainer>
      </ContentContainer>
    </JobAlertContainer>
  );
}

export default JobAlertToggle;
